import { Application } from '@hotwired/stimulus';
import WebauthnController from '../controllers/webauthn_controller';

const application = Application.start();

application.debug = process.env.NODE_ENV === 'development';

application.register('webauthn', WebauthnController);
